module.exports = __webpack_public_path__ + "static/media/menu.1a9d4140.mp4";